import type { WithActiveBranchId } from '@app/api/shared';

export enum PositionsEndpoints {
  UpdatePosition = 'UpdatePosition',
  GetPositionById = 'GetPositionById',
  GetPositions = 'GetPositions',
  GetPositionsForSystem = 'GetPositionsForSystem',
  GetPositionsByOrganizationId = 'GetPositionsByOrganizationId',
  GetPositionRoles = 'GetPositionRoles',
}

export interface ModelItem {
  Id: number;
  IdS: string | null;
  Name: string | null;
}

export interface ModelPosition {
  Id: number;
  Name: string | null;
  Description: string | null;
  IsDeleted: boolean;
  MigrateId: number | null;
  Roles: ModelItem[] | null;
}

export type UpdatePositionRequest = WithActiveBranchId<{
  // Roles: null бэкенд отклоняет (400). Если ролей нет — поле не передаём, бэкенд создаст пустой список
  data: Omit<ModelPosition, 'Roles'> & { Roles?: ModelItem[] };
}>;

export type GetPositionByIdRequest = WithActiveBranchId<{
  positionId: number;
}>;

export type GetPositionsRequest = WithActiveBranchId;

export type GetPositionsForSystemRequest = WithActiveBranchId;

export type GetPositionsByOrganizationIdRequest = WithActiveBranchId<{
  organizationId: number;
}>;

export type GetPositionRolesRequest = WithActiveBranchId;

export type UpdatePositionResponse = ModelPosition;
export type GetPositionByIdResponse = ModelPosition;
export type GetPositionsResponse = ModelPosition[];
export type GetPositionsForSystemResponse = ModelItem[];
export type GetPositionsByOrganizationIdResponse = ModelItem[];
export type GetPositionRolesResponse = ModelItem[];
